<app-modal-dialog [configuration]="modalDialogConfiguration" (closeModalEvent)="closeModalEvent($event)">
    <app-terms-of-use></app-terms-of-use>
</app-modal-dialog>
